import { createFormConfig, ValidationRules } from 'helpers/createFormConfig';
import { PersonalInformationFieldNames } from 'features/new-actor/enums/personalInformationFieldNames';
import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { NaturalPersonFormFieldNames } from 'features/new-actor/enums/naturalPersonFormFieldNames';
import {
  BorrowerInsuredFormFieldNames,
  BorrowerNaturalFormValues
} from '../borrowerInsuredForm';
import { borrowerNaturalPersonValidationRules } from './borrowerNatural.validation';

export const borrowerNaturalFormConfig =
  createFormConfig<BorrowerNaturalFormValues>(
    borrowerNaturalPersonValidationRules as ValidationRules<
      keyof BorrowerNaturalFormValues
    >,
    {
      [BorrowerInsuredFormFieldNames.BorrowerId]: undefined,
      [PersonalInformationFieldNames.Civility]: 'Mr',
      [AddressFormFieldNames.Country]: 'FR',
      [PersonalInformationFieldNames.Nationality]: 'FR',
      [PersonalInformationFieldNames.BirthCountry]: 'FR',
      [NaturalPersonFormFieldNames.TaxResidenceCountryId]: 'FR',
      [BorrowerInsuredFormFieldNames.ProspectType]: 'EMP'
    }
  );
